module.exports = __webpack_public_path__ + "static/media/tom jones headshot_1580483474612.3d1c57a9.png";